import { render } from "./ModalNfseConfirmation.vue?vue&type=template&id=3156ca34"
import script from "./ModalNfseConfirmation.vue?vue&type=script&lang=js"
export * from "./ModalNfseConfirmation.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__